import type {List, MapOf} from 'immutable';

/**
 * Calculates offset seconds needed per video to play HLS playlists back in sync with each other.
 */
export const getPlaylistOffsets = (
    videoFiles: List<
        MapOf<{
            videoId: string;
            startTs: Date;
        }>
    >,
): Record<string, number> => {
    const videoStartTimes = videoFiles
        .map<{videoId: string; startTs: number}>((f) => ({
            videoId: f.get('videoId'),
            startTs: f.get('startTs').getTime(),
        }))
        .toArray();
    const latestStartTime = Math.max(...videoStartTimes.map((v) => v.startTs));

    // calculate offsets for all videos
    const playlistOffsets: Record<string, number> = {};
    videoStartTimes.forEach((v) => {
        playlistOffsets[v.videoId] = (latestStartTime - v.startTs) / 1000; // convert to seconds
    });

    return playlistOffsets;
};
